import { render } from "./Others.vue?vue&type=template&id=4c6c9643&scoped=true"
import script from "./Others.vue?vue&type=script&lang=js"
export * from "./Others.vue?vue&type=script&lang=js"

import "./Others.vue?vue&type=style&index=0&id=4c6c9643&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6c9643"]])

export default __exports__